import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AcresFeature } from '../../models/features';

interface InitialState {
  boundaryTransfer: AcresFeature[];
}

const initialState: InitialState = {
  boundaryTransfer: [],
};

const boundaryTransferSlice = createSlice({
  initialState,
  name: 'boundary-transfer',
  reducers: {
    clearBoundaryTransfer: (state) => {
      state.boundaryTransfer = initialState.boundaryTransfer;
    },
    setBoundaryTransfer: (state, action: PayloadAction<AcresFeature[]>) => {
      state.boundaryTransfer = action.payload;
    },
  },
});

export const { setBoundaryTransfer, clearBoundaryTransfer } =
  boundaryTransferSlice.actions;

export default boundaryTransferSlice.reducer;
